/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-keyboard-navigation',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoKeyboardNavigationComponent extends NestedOption {
    @Input()
    get editOnKeyPress(): boolean {
        return this._getOption('editOnKeyPress');
    }
    set editOnKeyPress(value: boolean) {
        this._setOption('editOnKeyPress', value);
    }

    @Input()
    get enterKeyAction(): string {
        return this._getOption('enterKeyAction');
    }
    set enterKeyAction(value: string) {
        this._setOption('enterKeyAction', value);
    }

    @Input()
    get enterKeyDirection(): string {
        return this._getOption('enterKeyDirection');
    }
    set enterKeyDirection(value: string) {
        this._setOption('enterKeyDirection', value);
    }


    protected get _optionPath() {
        return 'keyboardNavigation';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoKeyboardNavigationComponent
  ],
  exports: [
    DxoKeyboardNavigationComponent
  ],
})
export class DxoKeyboardNavigationModule { }
